import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import moment from 'moment'

export interface DatePickerDialogData {
  title: string;
  date: moment.Moment;
  minDate?: moment.Moment;
}

@Component({
  selector: 'mmx-date-picker-dialog',
  templateUrl: './date-picker-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DatePickerDialogComponent {
  public formGroup = this.fb.group({
    date: this.fb.control(this.data.date, Validators.required),
  })

  public get min() {
    return this.data.minDate?.toDate() || new Date()
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DatePickerDialogData,
    private dialogRef: MatDialogRef<DatePickerDialogComponent>,
    private fb: FormBuilder,
  ) {}

  public onSubmit() {
    if (this.formGroup.invalid) {
      return
    }

    this.dialogRef.close(this.formGroup.value.date)
  }
}
